import React from "react"
import { compose } from "@albelli/photoselector"
import { ContainerListView, VerticalSquareLayout } from "@albelli/list-view-react"

import withRequest from "../../Http/withRequest"
import { CategoryItemContainer, PhotoOrganiserItem } from "../../Components/CategoryItemContainer"

interface YearsProps {
  navigateTo: (id: string) => void
  items: PhotoOrganiserItem[]
}

const Years: React.FunctionComponent<YearsProps> = ({ navigateTo, items }) => {
  const layout = new VerticalSquareLayout(300, 5)

  const styleClass = "photo-organiser-image-container-hover photo-organiser-image-container"

  return (
    <ContainerListView className={styleClass} layout={layout} items={items}>
      {(item) => <CategoryItemContainer item={item as PhotoOrganiserItem} navigateTo={navigateTo} />}
    </ContainerListView>
  )
}

export default compose(withRequest)(Years)
